export default function MapViewToggleControl(onPolygonClick, onPointClick, showPoints = false) {
  return {
    onAdd(map) {
      this.map = map;
      this.container = document.createElement("div");

      Object.assign(this.container.style, {
        position: "absolute",
        top: "10px",
        left: "10px",
        zIndex: "10",
        backgroundColor: "rgba(0,0,0,0.42)",
        padding: "6px",
        borderRadius: "20px",
        display: "flex",
        gap: "6px",
        pointerEvents: "auto",
        userSelect: "none",
      });

      const createBtn = (label, handler) => {
        const b = document.createElement("button");
        b.type = "button";
        b.textContent = label;
        Object.assign(b.style, {
          padding: "6px 10px",
          borderRadius: "16px",
          cursor: "pointer",
          fontWeight: 600,
          fontSize: "12px",
          color: "#fff",
          backgroundColor: "transparent",
          border: "none",
          outline: "none",
          pointerEvents: "auto",
        });

        // named listener so we can remove it in onRemove
        const listener = (ev) => {
          ev.stopPropagation();
          ev.preventDefault();
          try { handler && handler(); } catch (e) {}
          // sync visuals after handler runs (maps/layers may have changed)
          setTimeout(() => this.updateActive(), 60);
        };
        b._listener = listener;
        b.addEventListener("click", listener);
        b.addEventListener("keydown", (ev) => {
          if (ev.key === "Enter" || ev.key === " ") {
            ev.preventDefault();
            listener(ev);
          }
        });
        return b;
      };

      // create buttons and keep refs
      this.polygonBtn = createBtn("Polygons", () => { if (typeof onPolygonClick === "function") onPolygonClick(); });
      this.pointBtn = createBtn("Points", () => { if (typeof onPointClick === "function") onPointClick(); });

      // append
      this.container.appendChild(this.polygonBtn);
      this.container.appendChild(this.pointBtn);

      // helper to set active style
      this._setActive = (btn, active) => {
        btn.style.backgroundColor = active ? "#fff" : "transparent";
        btn.style.color = active ? "#000" : "#fff";
      };

      // updateActive reads layer visibility from the map to decide active state
      this.updateActive = (mapArg) => {
        const m = mapArg || this.map;
        if (!m) return;
        try {
          const fillVis = m.getLayoutProperty("parcel-fill", "visibility");
          const pointsVis = m.getLayoutProperty("parcel-points-layer", "visibility");
          const polygonsVisible = fillVis !== "none" && fillVis !== undefined;
          const pointsVisible = pointsVis === "visible";
          if (pointsVisible) {
            this._setActive(this.pointBtn, true);
            this._setActive(this.polygonBtn, false);
          } else if (polygonsVisible) {
            this._setActive(this.polygonBtn, true);
            this._setActive(this.pointBtn, false);
          } else {
            // fallback: use provided showPoints flag
            this._setActive(this.pointBtn, !!showPoints);
            this._setActive(this.polygonBtn, !showPoints);
          }
        } catch (e) {
          this._setActive(this.pointBtn, !!showPoints);
          this._setActive(this.polygonBtn, !showPoints);
        }
      };

      // small delay so layers can be created, then sync UI
      setTimeout(() => this.updateActive(), 300);

      return this.container;
    },

    onRemove() {
      // remove event listeners
      const safeRemove = (el) => {
        if (!el) return;
        if (el._listener) el.removeEventListener("click", el._listener);
        if (el.parentNode) el.parentNode.removeChild(el);
      };
      safeRemove(this.polygonBtn);
      safeRemove(this.pointBtn);
      if (this.container && this.container.parentNode) this.container.parentNode.removeChild(this.container);
      this.map = undefined;
      this.container = undefined;
      this.polygonBtn = undefined;
      this.pointBtn = undefined;
    },
  };
}